export default function WorkOrdersPage() {
  return (
    <>
      <div className="page__header">
        <div>
          <h1 className="page__title">Work Orders</h1>
          <div className="page__subtitle">Daily dispatch for all crews</div>
        </div>
        <button className="btn btn--primary">+ New Work Order</button>
      </div>
      <div className="card">
        <div className="card__body" style={{ color: 'var(--text-muted)' }}>
          Work-order board coming online — pulls from <code>/api/work-orders</code>.
        </div>
      </div>
    </>
  );
}
